import * as api from 'dashboard/resources/lvm-sales-history.api';
import sortBy from 'lodash/sortBy';
import actionTypes from './action-types';

export const fetchLvmSalesHistoryRequest = () => ({
  type: actionTypes.FETCH_LVM_SALES_HISTORY_REQUEST,
  isLoading: true,
});

export const fetchLvmSalesHistorySuccess = (data) => ({
  type: actionTypes.FETCH_LVM_SALES_HISTORY_SUCCESS,
  isLoading: false,
  data,
});

export const fetchLvmSalesHistoryFailure = () => ({
  type: actionTypes.FETCH_LVM_SALES_HISTORY_FAILURE,
  isLoading: false,
});

export const groupByGames = (data) => {
  const drawProductType = 1;
  const instantProductType = 2;
  const getGameItem = (item, totalPropertyName) => ({
    gameName: item.gameName,
    netSalesDelta: item.netSalesDelta,
    netSales: item.netSales,
    displayOrder: item.displayOrder,
    [totalPropertyName]: item[totalPropertyName],
  });
  const pushGame = (game, terminal) => {
    if (game.productType === drawProductType) {
      terminal.drawGames.push(getGameItem(game, 'drawTotal'));
    } else if (game.productType === instantProductType) {
      terminal.instantGames.push(getGameItem(game, 'instantTotal'));
    }
  };
  const isTheSameTerminal = (last, current) => last
      && last.periodType === current.periodType
      && last.terminalKey === current.terminalKey;

  data = sortBy(data, ['periodType', 'terminalKey', 'productType', 'gameName']).reduce((terminals, currentTerminal) => {
    const lastTerminal = terminals[terminals.length - 1];
    if (isTheSameTerminal(lastTerminal, currentTerminal)) {
      const game = currentTerminal;
      pushGame(game, lastTerminal);
    } else {
      const game = currentTerminal;
      game.isExpanded = false;
      game.drawGames = [];
      game.instantGames = [];
      pushGame(game, currentTerminal);
      terminals.push(currentTerminal);
    }
    return terminals;
  }, []);
  return data;
};

export const fetchLvmSalesHistory = (periodType, id = null) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = id || session.retailer.retailerId;

    dispatch(fetchLvmSalesHistoryRequest());
    const data = await api.fetchLvmSalesHistory(periodType, retailerId);
    const groupedData = groupByGames(data);
    dispatch(fetchLvmSalesHistorySuccess(groupedData));
  } catch (error) {
    console.error('LVM_SALES_HISTORY', error);
    dispatch(fetchLvmSalesHistoryFailure());
  }
};

export const fetchLvmSalesRequest = () => ({
  type: actionTypes.FETCH_LVM_SALES_REQUEST,
  isLoading: true,
});

export const fetchLvmSalesSuccess = (total) => ({
  type: actionTypes.FETCH_LVM_SALES_SUCCESS,
  isLoading: false,
  total,
});

export const fetchLvmSalesFailure = () => ({
  type: actionTypes.FETCH_LVM_SALES_FAILURE,
  isLoading: false,
});

export const fetchLvmSales = (id = null) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = id || session.retailer.retailerId;

    dispatch(fetchLvmSalesRequest());
    const total = await api.fetchLvmSales(retailerId);
    dispatch(fetchLvmSalesSuccess(total));
  } catch (error) {
    console.error('LVM_SALES', error);
    dispatch(fetchLvmSalesFailure());
  }
};

export const downloadLvmSalesHistoryReportRequest = () => ({
  type: actionTypes.DOWNLOAD_LVM_SALES_HISTORY_REPORT_REQUEST,
});

export const downloadLvmSalesHistoryReportSuccess = () => ({
  type: actionTypes.DOWNLOAD_LVM_SALES_HISTORY_REPORT_SUCCESS,
});

export const downloadLvmSalesHistoryReportFailure = () => ({
  type: actionTypes.DOWNLOAD_LVM_SALES_HISTORY_REPORT_FAILURE,
});

export const downloadLvmSalesHistoryReport = (extension, periodType, id = null) => (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = id || session.retailer.retailerId;

    dispatch(downloadLvmSalesHistoryReportRequest());
    dispatch(downloadLvmSalesHistoryReportSuccess());
    return api.downloadLvmSalesHistoryReport(extension, periodType, retailerId);
  } catch (error) {
    console.error('DOWNLOAD_LVM_SALES_HISTORY_REPORT', error);
    dispatch(downloadLvmSalesHistoryReportFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/lvm-sales-history/lvm-sales-history.actions.js